import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import api from '../../services/api';
import toast from 'react-hot-toast';
import { Voicemail, Play, Trash2, Mail, Phone } from 'lucide-react';
import { format } from 'date-fns';

export default function VoicemailPage() {
  const qc = useQueryClient();
  const [selectedExt, setSelectedExt] = useState(null);

  const { data: boxes = [] } = useQuery('voicemail-boxes', () => api.get('/voicemail').then(r => r.data));
  const { data: messages } = useQuery(
    ['voicemail-messages', selectedExt],
    () => selectedExt ? api.get('/voicemail/' + selectedExt + '/messages').then(r => r.data) : null,
    { enabled: !!selectedExt }
  );

  const delMut = useMutation(
    (id) => api.delete('/voicemail/messages/' + id),
    { onSuccess: () => { qc.invalidateQueries(['voicemail-messages', selectedExt]); toast.success('Mensaje eliminado'); },
      onError: () => toast.error('Error al eliminar') }
  );

  return (
    <div className="space-y-6">
      <div><h1 className="text-2xl font-bold text-white">Buzon de Voz</h1>
        <p className="text-gray-400 text-sm">{boxes.length} buzones configurados</p></div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="card">
          <h3 className="font-semibold text-white mb-3">Buzones</h3>
          <div className="space-y-2">
            {boxes.map(box => (
              <button key={box.id} onClick={() => setSelectedExt(box.extension_id)}
                className={'w-full text-left p-3 rounded-lg transition-colors ' + (selectedExt === box.extension_id ? 'bg-blue-600/20 border border-blue-600/30' : 'hover:bg-gray-800')}>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center">
                    <Phone size={13} className="text-gray-400" />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-gray-200">Ext. {box.number}</div>
                    <div className="text-xs text-muted">{box.caller_id_name}</div>
                  </div>
                  <span className={'ml-auto ' + (box.enabled ? 'badge-success' : 'badge-danger')}>
                    {box.enabled ? 'Act.' : 'Inact.'}
                  </span>
                </div>
              </button>
            ))}
            {!boxes.length && <p className="text-muted text-sm text-center py-6">Sin buzones</p>}
          </div>
        </div>

        <div className="card lg:col-span-2">
          <h3 className="font-semibold text-white mb-3">
            {selectedExt ? 'Mensajes' : 'Selecciona un buzon'}
          </h3>
          {messages?.data?.length ? (
            <div className="space-y-2">
              {messages.data.map(msg => (
                <div key={msg.id} className={'p-3 rounded-lg border ' + (msg.is_read ? 'bg-gray-800/30 border-gray-800' : 'bg-blue-900/10 border-blue-800/30')}>
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-sm font-medium text-gray-200">{msg.caller_name || msg.caller_id}</div>
                      <div className="text-xs text-muted">{msg.duration}s | {format(new Date(msg.created_at), 'dd/MM/yy HH:mm')}</div>
                    </div>
                    <div className="flex gap-1">
                      <a href={'/api/voicemail/messages/' + msg.id + '/play'}
                        aria-label="Reproducir mensaje"
                        className="p-1.5 text-gray-400 hover:text-green-400 rounded-lg">
                        <Play size={15} />
                      </a>
                      <button onClick={() => delMut.mutate(msg.id)}
                        aria-label="Eliminar mensaje"
                        className="p-1.5 text-gray-400 hover:text-red-400 rounded-lg">
                        <Trash2 size={15} />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : selectedExt ? (
            <div className="text-center py-12 text-muted">Sin mensajes en buzon</div>
          ) : (
            <div className="text-center py-12 text-muted">Selecciona un buzon para ver mensajes</div>
          )}
        </div>
      </div>
    </div>
  );
}
